/** @file tilePaintUi: the Tile screen's tool, colour, recent picks and toggles (shared by every Tile tab). */
import type { Rgba } from '@zilo/pose3d-image-io/types/image';
import { createStore } from 'zustand/vanilla';

/** The one-pixel tools: pencil (B), eraser (E), bucket (G), eyedropper (I), line (L). */
export type TileTool = 'pencil' | 'eraser' | 'bucket' | 'eyedropper' | 'line';

/** The view and stroke toggles: Mirror X (M), onion (O, off by default), the pixel grid. */
export type TileToggle = 'mirror' | 'onion' | 'grid';

/** Tool, colour, the 8 most recent picks (newest first) and the toggles, with their setters. */
export type TilePaintUiState = {
  tool: TileTool;
  color: Rgba;
  recent: Rgba[];
  mirror: boolean;
  onion: boolean;
  grid: boolean;
  setTool: (tool: TileTool) => void;
  /** Sets the current colour and puts it first among the recent picks (once). */
  pick: (color: Rgba) => void;
  toggle: (name: TileToggle) => void;
};

const RECENT = 8;
const same = (a: Rgba, b: Rgba): boolean => a.every((c, i) => c === b[i]);

/** The page's one paint UI store. */
export const tilePaintUi = createStore<TilePaintUiState>()((set) => ({
  tool: 'pencil',
  color: [0, 0, 0, 255],
  recent: [],
  mirror: false,
  onion: false,
  grid: true,
  setTool: (tool) => { set({ tool }); },
  pick: (color) => { set((s) => ({ color, recent: [color, ...s.recent.filter((c) => !same(c, color))].slice(0, RECENT) })); },
  toggle: (name) => { set((s) => ({ [name]: !s[name] })); },
}));
